import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "stringSplice",
    standalone: false
})
export class StringSplicePipe implements PipeTransform {
  transform(value: string, separator: string, returnMember: number): string {
    return value.split(separator)[returnMember].trim();
  }
}
